import React from 'react';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Headline,
  Body,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

export interface SelectionItem {
  title: string;
}

interface SelectionButtonProps {
  item: SelectionItem;
  onClick: () => void;
  isSelected: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

function SelectionButton({
  item,
  onClick,
  isSelected,
  onMouseEnter,
  onMouseLeave,
}: SelectionButtonProps) {
  return (
    <Stack
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
      border={`1px solid ${
        isSelected
          ? designSystemToken('semantic.bg.neutral')
          : designSystemToken('semantic.bg.neutral-inverse')
      }`}
      padding="24px"
      borderRadius="16px"
      onClick={onClick}
      sx={{
        'cursor': 'pointer',
        '&:hover': {
          backgroundColor: designSystemToken('semantic.bg.tertiary'),
        },
      }}
      // TODO: commented this out because not all features have a video asset. Return when we have a video asset for all features.
      // onMouseEnter={onMouseEnter ?? (() => {})}
      // onMouseLeave={onMouseLeave ?? (() => {})}
    >
      <Headline size="xs" paddingBlock="12px">
        {translate(item.title)}
      </Headline>
    </Stack>
  );
}

export default SelectionButton;
